import { selectConsultationAllowanceParams } from '@app/store/consultation/consultation.selectors';
import { createSelector } from '@ngrx/store';
/**
 * Selector for panel summary
 */
export const selectAllowanceSummary = createSelector(selectConsultationAllowanceParams, (params) => params?.deprecatedPetInfo);
